import { makeStyles } from "@material-ui/core";
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import clsx from 'clsx';
import { DashboardHeader } from "pages/admin/dashboard/components/general";

const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: 5, },
    '&::-webkit-scrollbar-thumb': { background: '#999999' }
  },
  chart: {
    width: '100%',
    height: '100%',
  },
  wrapRow: {
    padding: "5px 10px", borderBottom: "1px solid #F3f3f3",
    cursor: 'pointer'
  },
  wrapCreateInfo: {
    display: 'flex',
    marginTop: 5
  },
  newCreate: {
    display: 'flex',
    alignItems: 'center',
    color: "#707070", fontSize: "12px", marginRight: "10px"
  },
  newCreateBy: { color: "#707070", fontSize: "12px" },
  unRead: {
    backgroundColor: 'ghostwhite'
  }
}));



const data = [
  {
    newsName: "T0001 - ยื่นคำขอ Smart T",
    started: '5 hours ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
  {
    newsName: "T0002 - ยื่นคำขอ Smart I",
    started: '12 hours ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
  {
    newsName: "T0003 - ยื่นคำขอ Smart E",
    started: '1 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'
  },
  {
    newsName: "DEPA ยกเลิกคำร้อง T0001",
    started: '3 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },

  {
    newsName: "NIA  ยกเลิกคำร้อง T0001",
    started: '4 day ago',
    createBy: 'ธีรวัจน์ บุรวัตร์'

  },
]

function Notifications() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="Notifications" />
      </div>
      <div className={classes.wrapChart}>
        {
          data.map((d, index) => (
            <div key={index} className={clsx(classes.wrapRow, {
              [classes.unRead]: index <= 1,
            })}>
              <div style={{ color: "#1a0dab", fontSize: "14px" }}>
                {d.newsName}
              </div>

              <div className={classes.wrapCreateInfo}>
                <div className={classes.newCreate}>
                  <span>
                    <NotificationsNoneIcon size="small" style={{ color: 'rgb(153, 153, 153)', marginRight: 5 }} />
                  </span>
                  <div className={classes.newCreate}>
                    {d.started}
                  </div>
                  <div className={classes.newCreateBy}>
                    {d.createBy}
                  </div>
                </div>

              </div>
            </div>
          ))
        }


      </div>
    </>
  )
}


export default Notifications;